import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Form, Input } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, returnInwardFormData } from "./ReturnInwardFile";
import {
  dropdownData,
  getRecords,
  saveRecords,
  uploadFile,
  formatNumber,
} from "../../services/api.service";
import { toast } from "react-toastify";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";
import CustomError from "../../custom/components/Errors/CustomError";
import DatePicker from "../../custom/components/Date-Picker/DatePicker";
import { imageURL } from "../../services/api.service";
import NumberInput from "../../custom/components/Number-Input/NumberInput";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import SelectInputPercentage from "../../custom/components/Select-Input-Percentag/SelectInputPercentage";

const ReturnInwardCreate = () => {
  const { id } = useParams;
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    itemTypeOptions,
    inwardTypeOptions,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(returnInwardFormData());
  const [userSelect, setUserSelect] = useState("");
  const [userSelectOptions, setUserSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  const [warehouseSelect, setWarehouseSelect] = useState("");
  const [warehouseSelectOptions, setWarehouseSelectOptions] = useState([]);
  const [inwardTypeSelect, setInwardTypeSelect] = useState("");
  const [itemCodeSelect, setItemCodeSelect] = useState([]);
  const [itemSelectOptions, setItemSelectOptions] = useState([]);
  const [itemType, setItemType] = useState([
    { label: "Main", value: 1 },
    { label: "Faulty", value: 2 },
  ]);
  const [expandedRows, setExpandedRows] = useState({});
  const [returnItem, setReturnItem] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [filteredItems, setFilteredItems] = useState(
    formData?.inputData?.return_inward_items || []
  );
  const [filteredItemsdropdownData, setFilteredItemsDropdownData] = useState(
    []
  );
  const [groupedItems, setGroupedItems] = useState({});

  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const [fetchedStockData, setFetchedStockData] = useState([]);

  useEffect(() => {
    getUsereDropData();
    getWarehouseDropData();
    // getItemMasterDropData();
  }, []);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      inputRef.current &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }
  };
  useEffect(() => {
    const getInwardItemsData = async () => {
      try {
        const project_id = JSON.parse(localStorage.getItem("projectID"));
        if (
          !userSelect?.value ||
          !warehouseSelect?.value ||
          !inwardTypeSelect?.value
        ) {
          return;
        }

        let payload = {
          project_id: project_id,
          contractor_id: userSelect?.value,
          warehouse_id: warehouseSelect?.value,
          type: inwardTypeSelect?.value,
        };

        const responseData = await getRecords(
          payload,
          "/assignedRemainingItemList"
        );

        if (responseData?.code == 1 && responseData?.data) {
          const returnInwardItems = responseData?.data
            ?.filter((item) => {
              const { total_installed_qty, total_assigned_qty, remaining_qty } =
                item.item_details;
              return remaining_qty !== 0 || null;
            })
            ?.map((item) => ({
              item_id: item?.item_id,
              buy_item_id: item?.buy_item_id,
              item_code: item?.item_code,
              buy_item_code: item?.buy_item_code,
              description: item?.item_details?.item_desc,
              make_item_desc: item.item_desc,
              uom: item?.uom,
              make_item_uom: item?.item_uom,
              stock_qty: item?.item_details?.total_installed_qty,
              assigned_qty: item?.item_details?.total_assigned_qty,
              remaining_qty: item.item_details?.remaining_qty,
              is_make_item: item?.is_make_item,
              return_qty: null,
              is_active: true,
              type: 1,
              id: item.uniqueId,
              is_show: false,
              make_buy_name: item?.is_make_item
                ? item?.buy_item_code + " (" + item?.item_code + ")"
                : item?.buy_item_code,
            }));
          // Update the formData state
          setFormData((prevState) => ({
            ...prevState,
            inputData: {
              ...prevState.inputData,
              user_id: userSelect?.value,
              return_inward_items: returnInwardItems,
            },
          }));

          setFilteredItems(returnInwardItems);
          setFilteredItemsDropdownData(returnInwardItems);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getInwardItemsData();
  }, [userSelect, warehouseSelect, inwardTypeSelect]);

  useEffect(() => {
    const getInwardItemsProvisionData = async () => {
      if (inwardTypeSelect?.value === "Provision") {
        try {
          const project_id = JSON.parse(localStorage.getItem("projectID"));
          const contractor_id = JSON.parse(localStorage.getItem("userDetails"));

          if (!warehouseSelect?.value || !inwardTypeSelect?.value) {
            return;
          }

          let payload = {
            project_id: project_id,
            contractor_id: contractor_id?.id,
            warehouse_id: warehouseSelect?.value,
            type: inwardTypeSelect?.value,
          };

          const responseData = await getRecords(
            payload,
            "/assignedRemainingItemList"
          );

          if (responseData?.code == 1 && responseData?.data) {
            const returnInwardItems = responseData?.data
              ?.filter((item) => {
                const {
                  total_installed_qty,
                  total_assigned_qty,
                  remaining_qty,
                } = item.item_details;
                return remaining_qty !== 0 || null;
              })
              ?.map((item) => ({
                item_id: item?.item_id,
                buy_item_id: item?.buy_item_id,
                item_code: item?.item_code,
                buy_item_code: item?.buy_item_code,
                description: item?.item_details?.item_desc,
                make_item_desc: item.item_desc,
                uom: item?.uom,
                make_item_uom: item?.item_uom,
                stock_qty: item?.item_details?.total_installed_qty,
                assigned_qty: item?.item_details?.total_assigned_qty,
                remaining_qty: item.item_details?.remaining_qty,
                is_make_item: item?.is_make_item,
                return_qty: null,
                is_active: true,
                type: 1,
                id: item.uniqueId,
                is_show: false,
                make_buy_name: item?.is_make_item
                  ? item?.buy_item_code + " (" + item?.item_code + ")"
                  : item?.buy_item_code,
              }));
            // Update the formData state
            setFormData((prevState) => ({
              ...prevState,
              inputData: {
                ...prevState.inputData,
                user_id: userSelect?.value,
                return_inward_items: returnInwardItems,
              },
            }));

            setFilteredItems(returnInwardItems);
            setFilteredItemsDropdownData(returnInwardItems);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    getInwardItemsProvisionData();
  }, [warehouseSelect, inwardTypeSelect]);

  const getUsereDropData = async () => {
    try {
      let payload = {
        modelName: "user_masters",
        whereCondition: {
          is_active: true,
        },
        relations: [
          {
            module: "user_masters",
            moduleAs: "createdBy",
          },
          {
            module: "user_masters",
            moduleAs: "updatedBy",
          },
          {
            module: "user_masters",
            moduleAs: "subcontractor",
          },
        ],
        pagination: {
          page: 1,
          pageSize: 10000,
        },
      };

      const responseData = await getRecords(payload, "/listUser");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "first_name"
        );
        setUserSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = TransactionalValidation(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  useEffect(() => {
    setFilteredItemsDropdownData(filteredItems);
  }, [filteredItems]);
  // const handleInputChange = (e) => {
  //   const value = e.target.value;
  //   setInputValue(value);

  //   if (value.trim() === "") {
  //     setFilteredItemsDropdownData(filteredItems);
  //   } else {
  //     const filtered = filteredItems.filter(
  //       (item) =>
  //         item?.item_code?.toLowerCase().includes(value.toLowerCase()) ||
  //         item?.buy_item_code?.toLowerCase().includes(value.toLowerCase())
  //     );

  //     setFilteredItemsDropdownData(filtered);
  //   }
  // };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value === "") {
      setFilteredItemsDropdownData(
        formData?.inputData?.return_inward_items?.filter(
          (item) => item.is_show === false
        )
      );
    } else {
      const filtered = formData?.inputData?.return_inward_items?.filter(
        (item) =>
          (item?.buy_item_code?.toLowerCase().includes(value.toLowerCase()) ||
            item?.item_code?.toLowerCase().includes(value.toLowerCase())) &&
          item.is_show === false
      );

      setFilteredItemsDropdownData(filtered);
    }
  };
  const handleUserSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      user_id: selectedValue,
    });

    // Clear return_inward_items errors

    setUserSelect(options);

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      user_id: fieldError?.user_id || "",
    }));
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        user_id: selectedValue,
      },
    }));
    setGroupedItems({});
  };

  // Calculate totals for the columns
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const requiredFields = {
        warehouse_id: warehouseSelect?.value,
        type: inwardTypeSelect?.value,
      };
      if (inwardTypeSelect?.value !== "Provision") {
        requiredFields.user_id = userSelect?.value;
      }
      const validationErrors = TransactionalValidation(validationType, {
        ...formData.inputData,
        ...requiredFields,
      });
      if (formData.inputData.type === "Provision") {
        delete validationErrors["user_id"];
      }
      if (!inwardTypeSelect?.value) {
        validationErrors.type = "Type is required";
      }
      if (!warehouseSelect?.value) {
        validationErrors.warehouse_id = "Warehouse is required";
      }
      if (Object.keys(validationErrors).length > 0) {
        setFormErrors(validationErrors);
        return;
      }

      let updatedFormData = { ...formData };

      const additionalErrors = {};
      if (updatedFormData?.inputData?.return_inward_items) {
        updatedFormData?.inputData?.return_inward_items?.forEach(
          (row, index) => {
            if (row?.is_active === true) {
              if (Number(row?.return_qty) > 0) {
                ["type"].forEach((field) => {
                  const fieldValue = row[field]?.toString()?.trim();
                  if (!fieldValue) {
                    if (!additionalErrors.return_inward_items)
                      additionalErrors.return_inward_items = {};
                    if (!additionalErrors.return_inward_items[row.id])
                      additionalErrors.return_inward_items[row.id] = {};
                    additionalErrors.return_inward_items[row.id][field] = `${
                      field.replace(/_/g, " ").charAt(0).toUpperCase() +
                      field.replace(/_/g, " ").slice(1)
                    } is required.`;
                  }
                });
              }

              const returnQty = parseFloat(row?.return_qty);
              const remainingQty = parseFloat(row?.remaining_qty);

              if (returnQty > remainingQty) {
                if (!additionalErrors.return_inward_items)
                  additionalErrors.return_inward_items = {};
                if (!additionalErrors.return_inward_items[row.id])
                  additionalErrors.return_inward_items[row.id] = {};
                additionalErrors.return_inward_items[row.id][
                  "return_qty"
                ] = `Return quantity can't be bigger than remaining qty.`;
              }
              // if (returnQty <= 0) {
              //   if (!additionalErrors.return_inward_items) {
              //     additionalErrors.return_inward_items = {};
              //   }
              //   if (!additionalErrors.return_inward_items[index]) {
              //     additionalErrors.return_inward_items[index] = {};
              //   }
              //   additionalErrors.return_inward_items[index]["return_qty"] =
              //     "Invalid return qty";
              // }
            }
          }
        );
      }

      if (Object.keys(additionalErrors).length > 0) {
        setFormErrors(additionalErrors);
        return;
      }
      const hasActiveOutwardItem =
        updatedFormData?.inputData?.return_inward_items?.some(
          (item) => Number(item?.return_qty) > 0
        );

      if (!hasActiveOutwardItem) {
        toast.error(
          "Please enter an return quantity greater than 0 for at least one item."
        );
        return;
      }
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const project_id = JSON.parse(localStorage.getItem("projectID"));
      let transformedInputData = {
        warehouse_id: updatedFormData?.inputData?.warehouse_id,
        user_id: updatedFormData?.inputData?.user_id,
        project_id: updatedFormData?.inputData?.project_id,
        type: updatedFormData?.inputData?.type,
        remark: updatedFormData?.inputData?.remark,
        created_by: updatedFormData?.inputData?.created_by,
        date: new Date().toISOString().split("T")[0],
        is_active: updatedFormData?.inputData?.is_active,

        return_inward_items: updatedFormData?.inputData?.return_inward_items
          ?.filter(
            (item) =>
              item?.is_active && !isNaN(item.return_qty) && item.return_qty > 0
          )
          ?.map((item) => ({
            item_id: item?.item_id,
            buy_item_id: item?.buy_item_id,
            return_qty: parseFloat(item?.return_qty),
            is_make_item: item?.is_make_item,
            is_active: item?.is_active,
            stock_qty: item?.stock_qty,
            type:
              updatedFormData?.inputData?.type == "MRB" ||
              updatedFormData?.inputData?.type == "Provision"
                ? 1
                : item.type,
          })),
      };

      const updatedInputData = {
        ...transformedInputData,
        project_id: project_id,
        created_by: userDetails
          ? userDetails?.id || 1
          : updatedFormData?.inputData?.created_by,
      };

      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        relation: initialPayload?.relation,
        inputData: updatedInputData,
      };
      setLoadingData(true);
      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code === 1) {
        toast.success(`${headerName} saved successfully!`);
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getItemMasterByIdData = async (Id, index) => {
    try {
      const selectedItem = returnItem.find((option) => option.item_id == Id);

      if (!selectedItem) {
        console.warn(`Item with ID ${Id} not found`);
        return;
      }

      setFormData((prev) => {
        const updatedDetails = [...prev.inputData.return_inward_items];

        updatedDetails[index] = {
          ...updatedDetails[index],
          item_id: selectedItem.item_id,
          item_code: selectedItem.item_code,
          description: selectedItem.item_details?.item_desc || "",
          uom: selectedItem.uom,
          stock_qty: selectedItem.item_details?.remaining_qty || 0,
          is_active: true,
        };

        return {
          ...prev,
          inputData: {
            ...prev.inputData,
            return_inward_items: updatedDetails,
          },
        };
      });
    } catch (error) {
      console.error("Error fetching item data:", error);
    }
  };

  const handleItemTypeDropdownChange = (index, selected) => {
    if (!selected?.value) return;

    // Reset form errors for the specific item
    setFormErrors((prev) => ({
      ...prev,
      return_inward_items: {
        ...prev.return_inward_items,
        [index]: {
          ...prev.return_inward_items?.[index],
          type: "",
        },
      },
    }));

    // Update itemType with the selected type for a specific item

    // Update filteredItems and set the type for each item in the array
    // setFilteredItems((prev) => {
    //   const updatedArray = prev.map(
    //     (item, idx) =>
    //       item.id === index ? { ...item, type: selected?.value } : item // Set type for the selected item
    //   );
    //   return updatedArray;
    // });

    // Update formData return_inward_items and set the type for each item in the array
    setItemType((prev) => ({
      ...prev,
      [index]: selected,
    }));

    setFormData((prev) => {
      const updatedReturnInwardItems = prev.inputData.return_inward_items.map(
        (item, idx) =>
          item.id == index ? { ...item, type: selected?.value } : item // Set type for the selected item
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          return_inward_items: updatedReturnInwardItems,
        },
      };
    });

    setGroupedItems((prevGroupedItems) => {
      const updatedGroupedItems = { ...prevGroupedItems };

      Object.entries(updatedGroupedItems).forEach(([key, group]) => {
        group.buyItems = group.buyItems.map((item) =>
          item.id == index ? { ...item, type: selected?.value } : item
        );
      });

      return updatedGroupedItems;
    });
  };

  const handleDropdownChange = (index, selected) => {
    if (!selected?.value) return;

    setFormErrors((prev) => ({
      ...prev,
      return_inward_items: {
        ...prev.return_inward_items,
        [index]: {
          ...prev.return_inward_items?.[index],
          item_id: "",
        },
      },
    }));

    setItemCodeSelect((prev) => {
      const updatedArray = [...prev];
      updatedArray[index] = selected;
      return updatedArray;
    });

    getItemMasterByIdData(selected.value, index);
  };

  const handleWarehouseSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      warehouse_id: selectedValue,
    });

    setWarehouseSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      warehouse_id: fieldError?.warehouse_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        warehouse_id: selectedValue,
      },
    }));
  };
  const handleInwardTypeSelect = (options) => {
    const selectedValue = options ? options.value : null;
    const fieldError = TransactionalValidation(validationType, {
      type: selectedValue,
    });

    setInwardTypeSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      type: fieldError?.type || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        type: selectedValue,
      },
    }));
    setGroupedItems({});
    setFilteredItemsDropdownData([]);
  };

  const getWarehouseDropData = async (Id) => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      let payload = {
        modelName: "warehouse_masters",
        whereCondition: {
          is_active: true,
          project_id: projectId,
        },
      };
      const responseData = await getRecords(payload, "/getWarehouseListing");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "warehouse_name"
        );

        setWarehouseSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const selectedItems = formData?.inputData?.return_inward_items?.map(
    (row) => row.item_id
  );

  const handleAddItemDetail = () => {
    setTimeout(() => {
      document
        .getElementById("table-container")
        ?.scrollTo({ top: 9999, behavior: "smooth" });
      window.scrollTo({
        top: window.scrollY + 300,
        behavior: "smooth",
      });
    }, 100);
    let errors = {};

    formData?.inputData?.return_inward_items?.forEach((row, index) => {
      ["item_id", "type", "return_qty"].forEach((field) => {
        if (!row[field]?.toString().trim()) {
          errors.return_inward_items = {
            ...errors.return_inward_items,
            [index]: {
              ...errors.return_inward_items?.[index],
              [field]: `${field
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())} is required`,
            },
          };
        } else if (field === "return_qty") {
          const value = parseFloat(row[field]);
          if (value <= 0) {
            errors.return_inward_items = {
              ...errors.return_inward_items,
              [index]: {
                ...errors.return_inward_items?.[index],
                [field]: "Invalid return qty",
              },
            };
          }

          const returnQty = parseFloat(row?.return_qty);
          const remainingQty = parseFloat(row?.remaining_qty);
          if (returnQty > remainingQty) {
            if (!errors.return_inward_items) errors.return_inward_items = {};
            if (!errors.return_inward_items[index])
              errors.return_inward_items[index] = {};
            errors.return_inward_items[index][
              "return_qty"
            ] = `Return quantity can't be bigger than item qty.`;
          }
        }
      });
    });

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        return_inward_items: [
          ...prev.inputData?.return_inward_items,
          {
            item_id: null,
            description: "",
            uom: "",
            type: "",
            return_qty: null,
            stock_qty: null,
            is_active: true,
          },
        ],
      },
    }));
  };
  const handleQTYChange = (value, index, field) => {
    let error = null;

    setFormData((prevState) => {
      const updatedDetails = [...prevState.inputData?.return_inward_items];

      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
      };

      if (field === "return_qty") {
        const returnQty = parseFloat(value);
        const remainingQty = parseFloat(updatedDetails[index]?.stock_qty);

        if (returnQty > remainingQty) {
          error = "Return quantity can't be bigger than item qty.";
        } else if (returnQty <= 0) {
          error = "Invalid return qty";
        } else if (!returnQty) {
          error = "Return qty is required";
        }
      }

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          return_inward_items: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        return_inward_items: {
          ...prevErrors.return_inward_items,
          [index]: {
            ...prevErrors.return_inward_items?.[index],
            [field]: error,
          },
        },
      };
      return newErrors;
    });
  };

  const handleItemDetailInputChange = (e, itemCode, field) => {
    const { name, value } = e.target;
    const returnQty = value;

    const currentItemIndex = formData?.inputData?.return_inward_items.findIndex(
      (item) => item.id == itemCode
    );
    if (currentItemIndex == -1) return;

    const currentItem =
      formData?.inputData?.return_inward_items[currentItemIndex];
    const isActive = currentItem?.is_active;

    const errorMessage =
      isActive && returnQty === 0
        ? `${name.replace(/_/g, " ")} can't be zero.`
        : isActive &&
          field === "return_qty" &&
          returnQty > currentItem?.remaining_qty
        ? `${name.replace(/_/g, " ")} can't be bigger than remaining qty.`
        : "";

    setFormErrors((prev) => ({
      ...prev,
      return_inward_items: {
        ...prev.return_inward_items,
        [itemCode]: isActive
          ? { ...prev.return_inward_items?.[itemCode], [name]: errorMessage }
          : prev.return_inward_items?.[itemCode],
      },
    }));

    setFormData((prevState) => {
      const updatedDetails = [...prevState?.inputData?.return_inward_items];
      const currentItem = updatedDetails[currentItemIndex];

      if (!currentItem) return prevState;

      updatedDetails[currentItemIndex] = {
        ...currentItem,
        [name]: returnQty,
      };

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          return_inward_items: updatedDetails,
        },
      };
    });

    setGroupedItems((prevGroupedItems) => {
      const updatedGroupedItems = { ...prevGroupedItems };

      Object.entries(updatedGroupedItems).forEach(([key, group]) => {
        group.buyItems = group.buyItems.map((item) =>
          item.id == itemCode ? { ...item, return_qty: returnQty } : item
        );
      });

      return updatedGroupedItems;
    });
  };
  // const handleItemSelect = (selectedItem) => {
  //   setInputValue("");
  //   const isItemAlreadyAdded = filteredItems.some(
  //     (item) => item.id == selectedItem.id && item.is_show
  //   );

  //   if (isItemAlreadyAdded) {
  //     toast.error(`The item ${selectedItem.item_code} is already added.`);
  //     setIsDropdownVisible(false);
  //     return;
  //   }
  //   // if (selectedItem.is_show) {
  //   //   toast.error(`The item ${selectedItem.item_code} is already added.`);
  //   //   setIsDropdownVisible(false);

  //   //   return;
  //   // }

  //   const updatedFilteredItems = filteredItems.map((item) =>
  //     item.id == selectedItem.id
  //       ? { ...item, is_show: true, return_qty: null, type: 1 }
  //       : item
  //   );
  //   toast.success(`The item "${selectedItem.item_code}" added successfully`);

  //   setFilteredItems(updatedFilteredItems);

  //   setIsDropdownVisible(false);
  // };

  const handleItemSelect = (selectedGroup) => {
    setFilteredItemsDropdownData((prev) =>
      prev.map((item) =>
        item.id === selectedGroup.id ? { ...item, is_show: true } : item
      )
    );

    setGroupedItems((prevGroupedItems) => {
      const updatedGroupedItems = { ...prevGroupedItems };

      if (!selectedGroup) return prevGroupedItems;

      const groupKey = selectedGroup.item_code;

      if (!updatedGroupedItems[groupKey]) return prevGroupedItems;

      const group = updatedGroupedItems[groupKey];

      const selectedBuyItem = group.buyItems.find(
        (item) => item.id === selectedGroup.id
      );

      if (selectedBuyItem && selectedBuyItem.is_show) {
        toast.error(
          `The item "${selectedGroup.buy_item_code}" is already added.`
        );
        return prevGroupedItems;
      }

      if (group.makeItem) {
        group.makeItem = { ...group.makeItem, is_show: true };
      }

      group.buyItems = group.buyItems.map((item) =>
        item.id === selectedGroup.id ? { ...item, is_show: true } : item
      );

      toast.success(
        `The item "${selectedGroup.buy_item_code}" added successfully.`
      );

      return updatedGroupedItems;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      inputData: {
        ...prevFormData.inputData,

        return_inward_items: prevFormData.inputData?.return_inward_items?.map(
          (item) =>
            item.id === selectedGroup.id ? { ...item, is_show: true } : item
        ),
      },
    }));
    setIsDropdownVisible(false);
  };
  const handleRemoveItemDetail = (group, itemToRemove) => {
    const quantityField = "return_qty";
    setItemType((prev) => {
      const updatedItems = { ...prev };

      const itemKey = Object.keys(prev).find((key) => key == itemToRemove.id);

      if (itemKey) {
        delete updatedItems[itemKey];
      }

      return updatedItems;
    });

    setGroupedItems((prevItems) => {
      const updatedItems = { ...prevItems };

      if (updatedItems[group.makeItem.item_code]) {
        const updatedGroup = updatedItems[group.makeItem.item_code];

        if (updatedGroup.makeItem.unique_id === itemToRemove.unique_id) {
          updatedGroup.makeItem = { ...updatedGroup.makeItem, is_show: false };
          updatedGroup.buyItems = updatedGroup.buyItems.map((item) => ({
            ...item,
            is_show: false,
            [quantityField]: "",
          }));
          setFilteredItemsDropdownData((prev) =>
            prev.map((item) =>
              item.item_id == itemToRemove.item_id
                ? { ...item, is_show: false }
                : item
            )
          );
        } else {
          updatedGroup.buyItems = updatedGroup.buyItems.map((item) =>
            item.id === itemToRemove.id
              ? { ...item, is_show: false, [quantityField]: "" }
              : item
          );

          const remainingVisibleBuyItems = updatedGroup.buyItems.filter(
            (item) => item.is_show
          );

          if (remainingVisibleBuyItems.length === 0) {
            updatedGroup.makeItem = {
              ...updatedGroup.makeItem,
              is_show: false,
              [quantityField]: "",
            };
          }
          setFilteredItemsDropdownData((prev) =>
            prev.map((item) =>
              item.id === itemToRemove.id ? { ...item, is_show: false } : item
            )
          );
        }
      }

      return updatedItems;
    });

    setFilteredItemsDropdownData((prev) =>
      prev.map((item) =>
        item.id == itemToRemove.id
          ? { ...item, is_show: false, return_qty: null, type: 1 }
          : item
      )
    );

    setFormData((prevState) => {
      if (!prevState?.inputData?.return_inward_items) return prevState;

      const updatedDetails = [...prevState.inputData.return_inward_items];

      const currentItemIndex = updatedDetails.findIndex(
        (item) => item.id === itemToRemove.id
      );

      if (currentItemIndex === -1) return prevState;

      updatedDetails[currentItemIndex] = {
        ...updatedDetails[currentItemIndex],
        [quantityField]: "",
        is_show: false,
      };

      return {
        ...prevState,
        inputData: {
          ...prevState.inputData,
          return_inward_items: updatedDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      if (!prevErrors?.return_inward_items) return prevErrors;

      const updatedErrors = { ...prevErrors };

      if (itemToRemove.unique_id === group.makeItem.unique_id) {
        group.buyItems.forEach((buyItem) => {
          delete updatedErrors.return_inward_items?.[buyItem.id];
        });
      } else {
        delete updatedErrors.return_inward_items?.[itemToRemove.id];
      }

      return updatedErrors;
    });
  };

  // const handleRemoveItemDetail = (selectedItem) => {
  //   const updatedFilteredItems = filteredItems.map((item) =>
  //     item.id === selectedItem.id
  //       ? { ...item, is_show: false, return_qty: null, type: 1 }
  //       : item
  //   );
  //   setItemType((prev) => {
  //     const updatedArray = [...prev];
  //     const index = filteredItems.findIndex(
  //       (item) => item.id === selectedItem.id
  //     );
  //     if (index !== -1) {
  //       updatedArray[index] = itemSelectOptions[0];
  //     }
  //     return updatedArray;
  //   });

  //   setFilteredItems(updatedFilteredItems);
  //   setFormData((prev) => ({
  //     ...prev,
  //     inputData: {
  //       ...prev.inputData,
  //       return_inward_items: updatedFilteredItems,
  //     },
  //   }));
  // };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) return;

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);

  let serialNumber = 1;

  return (
    <CustomForm
      title={"CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="type"
            value={inwardTypeSelect}
            options={inwardTypeOptions}
            onSelect={(selected) => handleInwardTypeSelect(selected)}
            placeholder="Select Type"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.type}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Warehouse"
            value={warehouseSelect}
            options={warehouseSelectOptions}
            onSelect={(selected) => handleWarehouseSelect(selected)}
            placeholder="Select warehouse"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.warehouse_id}
          />
        </Col>
        {inwardTypeSelect?.value !== "Provision" && (
          <Col md="6" className="mt-3">
            <SelectInput
              label="User"
              value={userSelect}
              options={userSelectOptions}
              onSelect={(selected) => handleUserSelect(selected)}
              placeholder="Select user"
              labelClassName="form-label"
              isClearable={false}
              asterisk={true}
              customError={formErrors?.user_id}
            />
          </Col>
        )}
        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Remark"
            name="remark"
            value={formData?.inputData?.remark}
            onChange={onInputChange}
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Remark"
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginLeft: "",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBlock: "5px",
            gap: "1rem",
          }}
        >
          <div>
            <h6 className="h-6-heading m-0">Item Details</h6>
          </div>
          <div>
            <div className="app-search d-flex d-lg-inline mt-0 w-25">
              <div className="position-relative">
                {" "}
                <input
                  ref={inputRef}
                  type="text"
                  className="form-control ps-5"
                  placeholder="Add item code..."
                  value={inputValue}
                  onChange={handleInputChange}
                  onFocus={() => {
                    setIsDropdownVisible(true);
                  }}
                  style={{
                    width: "13rem",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    borderColor: "#D2D2D2",
                    outline: "none",
                    transition: "all 0.3s ease",
                    boxShadow: "none",
                    marginRight: "0.5rem",
                  }}
                />
                <span className="ri-search-line"></span>
              </div>
            </div>
            {isDropdownVisible && (
              <div
                ref={dropdownRef}
                style={{
                  width: "13rem",
                  maxHeight: "150px",
                  overflowY: "auto",
                  border: "1px solid #D2D2D2",
                  borderRadius: "8px",
                  marginTop: "5px",
                  position: "absolute",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  zIndex: "1000",
                }}
              >
                {filteredItemsdropdownData?.some((row) => !row.is_show) ? (
                  filteredItemsdropdownData
                    ?.filter((row) => !row.is_show)
                    ?.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleItemSelect(item)}
                        style={{
                          padding: "8px 15px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f0f0f0")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        {item.make_buy_name}
                      </div>
                    ))
                ) : (
                  <div
                    style={{
                      padding: "8px 15px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                      textAlign: "center",
                      color: "gray",
                    }}
                  >
                    No Data..
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
        <div
          id="table-container"
          className="table"
          style={{
            overflow: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table
            className="table table-hover"
            style={{ tableLayout: "auto", minWidth: "100%" }}
          >
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 40000,
              }}
            >
              <tr
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1050,
                  backgroundColor: "#8AC1E8",
                  borderBottom: "1px solid black",
                }}
              >
                <th style={{ whiteSpace: "nowrap", minWidth: "80px" }}>
                  Sr. No
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
                  Item Code <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "150px" }}>
                  Item Description
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "80px" }}>UOM</th>

                <th style={{ whiteSpace: "nowrap", minWidth: "100px" }}>
                  Assigned Qty
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "100px" }}>
                  Stock Qty
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
                  Remaining QTY
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "150px" }}>
                  Type
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
                  Return Inward Qty
                </th>
                <th style={{ whiteSpace: "nowrap", minWidth: "100px" }}>
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {Object.values(groupedItems).length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    No data available.
                  </td>
                </tr>
              ) : Object.values(groupedItems).every(
                  (group) =>
                    !group.makeItem.is_show &&
                    group.buyItems.every((item) => !item.is_show)
                ) ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    Please add item from dropdown.
                  </td>
                </tr>
              ) : (
                Object.values(groupedItems)?.map((group, index) => (
                  <React.Fragment key={group.makeItem.unique_id}>
                    {group.makeItem.is_make_item == true &&
                      group.makeItem.is_show && (
                        <tr
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f0f8ff",
                          }}
                        >
                          <td>{serialNumber++}</td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={group.makeItem.item_code || "N/A"}
                            >
                              {group.makeItem.item_code || "N/A"}
                            </div>
                          </td>
                          {/* <td>{"-"}</td> */}
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            {" "}
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={group.makeItem.make_item_desc || "N/A"}
                            >
                              {group.makeItem.make_item_desc || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {" "}
                            {group.makeItem.make_item_uom || "N/A"}
                          </td>
                          <td>{"-"}</td>
                          <td>{"-"}</td>
                          <td>{"-"}</td>
                          <td>{"-"}</td>
                          <td>{"-"}</td>
                          <td
                            onClick={() =>
                              handleRemoveItemDetail(group, group.makeItem)
                            }
                          >
                            <Link className="text-danger">
                              <i className="mdi mdi-trash-can font-size-20"></i>
                            </Link>
                            {/* </div> */}
                          </td>{" "}
                        </tr>
                      )}
                    {group?.buyItems
                      ?.filter(
                        (item) => item.is_show && item.is_make_item == true
                      )
                      ?.map((row, subIndex) => (
                        <tr
                          key={row.unique_id}
                          style={{ borderBottom: "1px solid #ccc" }}
                        >
                          <td>{`${serialNumber - 1}.${subIndex + 1}`}</td>
                          {/* <td></td> */}
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.buy_item_code || "N/A"}
                            >
                              {row?.buy_item_code || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.uom || "N/A"}
                          </td>
                          <td>{formatNumber(row?.assigned_qty) || "0"}</td>
                          <td>{formatNumber(row?.stock_qty) || "0"}</td>
                          <td>{formatNumber(row?.remaining_qty) || "0"}</td>
                          {formData?.inputData?.type == "MRB" ||
                          formData?.inputData?.type == "Provision" ? (
                            // <td>Main</td>
                            <td>
                              <SelectInput
                                value={itemTypeOptions[0]}
                                options={[itemTypeOptions[0]]}
                                placeholder="Select type"
                                isClearable={false}
                                labelStyle={{ display: "none" }}
                                customError={
                                  formErrors?.return_inward_items?.[row.id]
                                    ?.type
                                }
                              />
                            </td>
                          ) : (
                            <td>
                              <SelectInput
                                value={itemType[row.id] || itemTypeOptions[0]}
                                options={itemTypeOptions}
                                onSelect={(selected) =>
                                  handleItemTypeDropdownChange(row.id, selected)
                                }
                                placeholder="Select type"
                                isClearable={false}
                                labelStyle={{ display: "none" }}
                                customError={
                                  formErrors?.return_inward_items?.[row.id]
                                    ?.type
                                }
                              />
                            </td>
                          )}
                          <td>
                            <NumberInput
                              name="return_qty"
                              onChange={(e) =>
                                handleItemDetailInputChange(
                                  e,
                                  row?.id,
                                  "return_qty"
                                )
                              }
                              value={row?.return_qty || ""}
                              inputClassName="form-control"
                              labelClassName="form-label"
                              placeholder="Return QTY"
                              disabled={false}
                              labelStyle={{ display: "none" }}
                              customError={
                                (formErrors?.return_inward_items &&
                                  formErrors?.return_inward_items[row.id]
                                    ?.return_qty) ||
                                ""
                              }
                            />
                          </td>
                          <td
                            onClick={() => handleRemoveItemDetail(group, row)}
                          >
                            <Link className="text-danger">
                              <i className="mdi mdi-trash-can font-size-20"></i>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    {group?.buyItems
                      ?.filter(
                        (item) => item?.is_show && item?.is_make_item == false
                      )
                      ?.map((row, subIndex) => (
                        <tr
                          key={row.unique_id}
                          style={{ borderBottom: "1px solid #ccc" }}
                        >
                          <td>{serialNumber++}</td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.item_code || "N/A"}
                            >
                              {row?.item_code || "N/A"}
                            </div>
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.description || "N/A"}
                            >
                              {row?.description || "N/A"}
                            </div>
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.uom || "N/A"}
                          </td>
                          <td>{formatNumber(row?.assigned_qty) || "0"}</td>
                          <td>{formatNumber(row?.stock_qty) || "0"}</td>
                          <td>{formatNumber(row?.remaining_qty) || "0"}</td>
                          {formData?.inputData?.type == "MRB" ||
                          formData?.inputData?.type == "Provision" ? (
                            // <td>Main</td>
                            <td>
                              <SelectInput
                                value={itemTypeOptions[0]}
                                options={[itemTypeOptions[0]]}
                                placeholder="Select type"
                                isClearable={false}
                                labelStyle={{ display: "none" }}
                                customError={
                                  formErrors?.return_inward_items?.[row.id]
                                    ?.type
                                }
                              />
                            </td>
                          ) : (
                            <td>
                              <SelectInput
                                value={itemType[row.id] || itemTypeOptions[0]}
                                options={itemTypeOptions}
                                onSelect={(selected) =>
                                  handleItemTypeDropdownChange(row.id, selected)
                                }
                                placeholder="Select type"
                                isClearable={false}
                                labelStyle={{ display: "none" }}
                                customError={
                                  formErrors?.return_inward_items?.[row.id]
                                    ?.type
                                }
                              />
                            </td>
                          )}
                          <td>
                            <NumberInput
                              name="return_qty"
                              onChange={(e) =>
                                handleItemDetailInputChange(
                                  e,
                                  row?.id,
                                  "return_qty"
                                )
                              }
                              value={row?.return_qty || ""}
                              inputClassName="form-control"
                              labelClassName="form-label"
                              placeholder="Return QTY"
                              disabled={false}
                              labelStyle={{ display: "none" }}
                              customError={
                                (formErrors?.return_inward_items &&
                                  formErrors?.return_inward_items[row.id]
                                    ?.return_qty) ||
                                ""
                              }
                            />
                          </td>

                          <td>
                            <div
                              onClick={() => handleRemoveItemDetail(group, row)}
                            >
                              <Link className="text-danger">
                                <i className="mdi mdi-trash-can font-size-20"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Row>
    </CustomForm>
  );
};

export default ReturnInwardCreate;
